import React, { useState } from "react";
import { connect } from "react-redux";
import MerchantDetailPanel from "../../../../shared/MerchantDetailPanel";

const BG = "#2c2d3f";

function Merchants({ merchants }) {
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState(null);

  const allMerchants = merchants || [];
  const filtered = allMerchants.filter((m) => {
    const q = search.toLowerCase();
    return !q || [m.email, m.storeInfo?.storeName, m.plan].some((v) => v && v.toLowerCase().includes(q));
  });

  return (
    <div>
      {selected && (
        <MerchantDetailPanel
          merchant={selected}
          onClose={() => setSelected(null)}
          canViewSensitive={false}
        />
      )}

      <div style={styles.header}>
        <div>
          <h2 style={styles.heading}>My Merchants</h2>
          <p style={styles.subText}>{allMerchants.length} merchant{allMerchants.length !== 1 ? "s" : ""} referred by you</p>
        </div>
      </div>

      <div style={styles.searchBox}>
        <i className="bi bi-search" style={{ color: "#bbb", marginRight: 8 }} />
        <input
          style={styles.searchInput}
          placeholder="Search by store name, email or plan…"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      {filtered.length === 0 ? (
        <div style={styles.empty}>
          <i className="bi bi-shop" style={{ fontSize: 40, color: "#ccc" }} />
          <p style={{ marginTop: 12, color: "#888" }}>No merchants found.</p>
        </div>
      ) : (
        <div style={{ overflowX: "auto" }}>
          <table style={styles.table}>
            <thead>
              <tr>
                {["Store / Email", "Plan", "Subscription", "Commission", "Last Login", "Joined", ""].map((h) => (
                  <th key={h} style={styles.th}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filtered.map((m) => {
                const isActive = m.subscriptionEnd && new Date() < new Date(m.subscriptionEnd);
                const storeName = m.storeInfo?.storeName;
                const commission = m.payment && m.payment.length > 0 ? parseInt(m.payment[0]?.price || 0, 10) : 0;
                return (
                  <tr key={m._id} style={styles.tr}>
                    <td style={styles.td}>
                      <div style={{ fontWeight: 600, color: BG, fontSize: 13 }}>{storeName || m.email}</div>
                      {storeName && <div style={{ fontSize: 11, color: "#999" }}>{m.email}</div>}
                    </td>
                    <td style={styles.td}>{m.plan || "Free"}</td>
                    <td style={styles.td}>
                      <span style={{
                        background: isActive ? "rgba(167,204,72,0.15)" : "#f5f5f5",
                        color: isActive ? "#5a8a00" : "#888",
                        borderRadius: 20, padding: "2px 12px", fontSize: 11, fontWeight: 600,
                      }}>
                        {isActive ? "Active" : "Inactive"}
                      </span>
                    </td>
                    <td style={styles.td}>
                      <span style={{ fontWeight: 700, color: commission > 0 ? "#5a8a00" : "#aaa" }}>
                        {commission > 0 ? "₦" + commission.toLocaleString() : "—"}
                      </span>
                    </td>
                    <td style={styles.td}>
                      <div style={{ fontSize: 12, color: "#555" }}>
                        {m.lastLogin ? new Date(m.lastLogin).toLocaleDateString() : "Never"}
                      </div>
                      {m.lastLogin && (
                        <div style={{ fontSize: 10, color: "#bbb" }}>
                          {new Date(m.lastLogin).toLocaleTimeString()}
                        </div>
                      )}
                    </td>
                    <td style={styles.td}>
                      {m.createdAt ? new Date(m.createdAt).toLocaleDateString() : "—"}
                    </td>
                    <td style={styles.td}>
                      <button style={styles.viewBtn} onClick={() => setSelected(m)}>
                        <i className="bi bi-eye-fill" style={{ marginRight: 4 }} />View
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

const styles = {
  header: { marginBottom: 16 },
  heading: { fontSize: 22, fontWeight: 700, color: BG, margin: 0 },
  subText: { color: "#888", fontSize: 13, marginTop: 4 },
  searchBox: { display: "flex", alignItems: "center", background: "#fff", border: "1.5px solid #e0e0e0", borderRadius: 8, padding: "8px 14px", marginBottom: 16 },
  searchInput: { border: "none", outline: "none", fontSize: 14, flex: 1, background: "transparent" },
  table: { width: "100%", borderCollapse: "collapse", background: "#fff", borderRadius: 10, overflow: "hidden", boxShadow: "0 2px 8px rgba(0,0,0,0.06)" },
  th: { background: BG, color: "#fff", padding: "12px 14px", textAlign: "left", fontSize: 12, fontWeight: 600, whiteSpace: "nowrap" },
  tr: { borderBottom: "1px solid #f0f0f0" },
  td: { padding: "12px 14px", fontSize: 13, color: "#444", verticalAlign: "middle" },
  viewBtn: { background: "rgba(79,176,198,0.12)", color: "#2980b9", border: "1px solid #4fb0c6", borderRadius: 6, padding: "5px 14px", cursor: "pointer", fontSize: 12, fontWeight: 600, display: "inline-flex", alignItems: "center" },
  empty: { textAlign: "center", padding: 60, background: "#fff", borderRadius: 10 },
};

const mapStateToProps = (state) => ({
  merchants: state.profile.agentMerchant,
});
export default connect(mapStateToProps)(Merchants);
